const PageHeader = ({ eyebrow, title, children }) => (
  <section className="page-header">
    <div className="container">
      <p className="eyebrow eyebrow--light">{eyebrow}</p>
      <h1>{title}</h1>
      {children && <p className="page-header__lead">{children}</p>}
    </div>
  </section>
);

export default PageHeader;
